
import capitalizeFirstLetter from "~/mixins/capitalizeFirstLetter";
import benefits from '../benefits/benefits.vue';

export default {
	components: { benefits },
	mixins: [capitalizeFirstLetter],
	props: {
		pageTitle: String,
		offers: {
			type: Boolean,
			default: false,
		},
	},
    methods: {
    scrollToElem() {
      let headerHeight = this.$device.isMobile ? 80 : 140;
      let currentRef = "catalog";
      if (this.$refs[currentRef]) {
        setTimeout(() => {
          window.scrollTo(0, this.$refs[currentRef]?.offsetTop - headerHeight);
        }, 500);
      }
    },
  },
  mounted() {
    if (this.$route.query.to_car || this.$route.name === "category-mark-model-car" || this.$route.name === "category-mark-model") {
      this.scrollToElem();
    }
  },
};
